import { neighborHoods, usBoundaries } from '@/constants/Project';

const normalizeCityKey = (city: string) => city.trim().toLowerCase();

const neighborhoodsForLegacyCity = (cityKey: string): string[] | undefined => {
  const neighborhoods = neighborHoods
    .filter((entry) => entry.city === cityKey)
    .map((entry) => entry.name.trim())
    .filter(Boolean);

  return neighborhoods.length > 0 ? neighborhoods : undefined;
};

export const fetchNeighborhoods = ({ state, city }: { state: string; city: string; district?: number }) => {
  if (!city?.trim()) {
    return undefined;
  }

  const cityKey = normalizeCityKey(city);
  const usStateBoundariesInfo = usBoundaries.find((b) => b.state.short_name === state);

  if (usStateBoundariesInfo) {
    const cityBoundariesInfo = usStateBoundariesInfo.cities.find((b) => normalizeCityKey(b.name) === cityKey);

    const neighborhoods = cityBoundariesInfo?.district.flatMap((d) => d.neighborhoods);
    if (neighborhoods?.length) {
      return neighborhoods;
    }
  }

  const byCity = neighborhoodsForLegacyCity(cityKey);
  if (byCity) {
    return byCity;
  }

  // City may be a neighborhood name (e.g. Bridgeport within Chicago).
  const hostCity = neighborHoods.find((entry) => normalizeCityKey(entry.name) === cityKey)?.city;
  if (hostCity) {
    return neighborhoodsForLegacyCity(hostCity);
  }

  return undefined;
};
